import RedemptionError from './redemption-error.container';

export default RedemptionError;
